import { Accordion } from '../../../../../components/general/accordion';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import { TitleV1 } from '../../../../../components/titleV1';
import LoadingButtonGeneral from '../../../../../components/general/buttons/loadingButtonGeneral';
import SearchIcon from '@mui/icons-material/Search';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SARLAFT } from '../../../../../../routes/paths';
import { SarlaftForm } from '../../../sarlaft/form';
import { AccountRegisterCaseSarlaftProps } from './props';

export const AccountRegisterCaseSarlaft = ({
    account,
    isOpen,
}: AccountRegisterCaseSarlaftProps) => {
    const navigate = useNavigate();

    return (
        <Accordion
            title="REGISTRO CASO SARLAFT"
            icon={<EmojiPeopleIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={isOpen}
            mt={0}
            padding={0}
        >
            <TitleV1 title="CASO SARLAFT">
                <LoadingButtonGeneral
                    title="Buscar"
                    variant="outlined"
                    startIcon={<SearchIcon />}
                    onClick={() => navigate(SARLAFT)}
                />
            </TitleV1>
            <Grid px="16px">
                <SarlaftForm account={account} />
            </Grid>
        </Accordion>
    );
};
